import React from 'react'
import { STextContent, STextContentHeader, SText, SDivider } from './styles'
import { FiExternalLink } from 'react-icons/fi'
const ToolsPage = () => {
	return (
		<>
			<STextContent>
				<STextContentHeader>THORChain Ecosystem Guide</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://tcecosystem.guide" target="_blank" rel="noreferrer">
								tcecosystem <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://devops.thorchain.org" target="_blank" rel="noreferrer">
								thorchain devops <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
				<SDivider />
				<STextContentHeader>THORChain Docs</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://docs.thorchain.org" target="_blank" rel="noreferrer">
								TCDocs <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://dev.thorchain.org/index.html" target="_blank" rel="noreferrer">
								TCDevDocs <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
				<SDivider />
				<STextContentHeader>Rune.Tools</STextContentHeader>
				<SText>
					THORChain tools{' '}
					<a href="https://rune.tools" target="_blank" rel="noreferrer">
						rune.tools <FiExternalLink />
					</a>
				</SText>
				<SDivider />
				<STextContentHeader>Block explorer</STextContentHeader>
				<SText>
					View your wallet history, assets {'&'} transactions{' '}
					<ul>
						<li>
							<a href="https://thorchain.net/dashboard" target="_blank" rel="noreferrer">
								THORChain Explorer <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://runescan.io" target="_blank" rel="noreferrer">
								RuneScan Explorer <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
				<SDivider />
				<STextContentHeader>Swap on THORChain</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://thordex.eth.limo/?ref=tch" target="_blank" rel="noreferrer">
								THORDex <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
				<SDivider />
				<STextContentHeader>THORChain wallets</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://vultisig.com" target="_blank" rel="noreferrer">
								Vultisig <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://www.thorwallet.org" target="_blank" rel="noreferrer">
								THORWallet <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://trustwallet.com/" target="_blank" rel="noreferrer">
								Trust Wallet <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>

				<SDivider />

				{/* <STextContentHeader>Community {'&'} NFTs</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://www.vanirthreads.com" target="_blank" rel="noreferrer">
								Vanir Threads <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://thorguards.com" target="_blank" rel="noreferrer">
								THORGuards <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
				<SDivider /> */}
				<STextContentHeader>Analytics</STextContentHeader>
				<SText>
					<ul>
						<li>
							<a href="https://boone.tools/status" target="_blank" rel="noreferrer">
								boone.tools <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://raynalytics.net" target="_blank" rel="noreferrer">
								raynalytics <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://thorchain.net/dashboard" target="_blank" rel="noreferrer">
								THORChain Explorer <FiExternalLink />
							</a>
						</li>
						<li>
							<a href="https://thornode.network" target="_blank" rel="noreferrer">
								THORNode Monitor <FiExternalLink />
							</a>
						</li>
					</ul>
				</SText>
			</STextContent>
		</>
	)
}

export default ToolsPage
